export const initialState = {
   open: false,
   message: '',
   severity: ''
}

const OPEN_SNACKBAR = 'OPEN_SNACKBAR'
const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'

export const closeSnackbarAction = () => ({ type: CLOSE_SNACKBAR })
export const openSnackBarAction = (message, severity) => ({
   type: OPEN_SNACKBAR,
   openMessage: { message, severity }
})

export default function openSnackbarReducer(state = initialState, action = {}) {
   const { type, openMessage = {} } = action
   const { severity, message } = openMessage
   switch (type) {
      case OPEN_SNACKBAR:
         return {
            open: true,
            message,
            severity: severity || 'error'
         }
      case CLOSE_SNACKBAR:
         return initialState
      default:
         return state
   }
}
